export var sizes = {
  maxWidth: '1440px',
  maxWidthInner: '1202px',
  columnWidth: 71,
  columnGap: 48,
  columnCount: 12,
  logoWidth: '100px',
  logoHeight: '34px',
  navHeight: 60,
  mobileNavHeight: 105,
  collapsedNavHeight: 6,
  maxSectionWidth: '1000px',
  maxNumberComponentWidth: '150px',
  maxLargeComponentWidth: '700px',
  maxMediumInputWidth: '450px',
  maxSmallInputWidth: '300px'
};